export const VUEX_FILTERBAR_QUERYUPDATE_QUERY_CLEAR = 'VUEX_FILTERBAR_QUERYUPDATE_QUERY_CLEAR'
export const VUEX_FILTERBAR_QUERYUPDATE_UPDATE_QUERY = 'VUEX_FILTERBAR_QUERYUPDATE_UPDATE_QUERY'
export const VUEX_FILTERBAR_QUERY_CONSTRUCT_CHIPS_FROM_QUERY = 'VUEX_FILTERBAR_QUERY_CONSTRUCT_CHIPS_FROM_QUERY'
export const VUEX_FILTERBAR_QUERYUPDATE_SHARE_LINK_SAVE_ANNOUNCEMENT = 'VUEX_FILTERBAR_QUERYUPDATE_SHARE_LINK_SAVE_ANNOUNCEMENT'
export const VUEX_FILTERBAR_QUERYUPDATE_SHARE_LINK = 'VUEX_FILTERBAR_QUERYUPDATE_SHARE_LINK'
